<div class="p-fluid">
    <div class="p-field">
        <label for="barkod" kodit-form-label>Naziv šablona</label>
        <input #filterSablonNaziv type="text" pInputText>
    </div>
</div>